<div class="content">
  <div class="content-panel">
    <div class="searchBar">
      <label class="form-label" for="searchBar-input" translate>page.admin.organismes.liste.table.filtrer</label>
      <input type="text" id="searchBar-input" (ngModelChange)="searchStringUpdate.next($event)" [(ngModel)]="searchStringInput"
        placeholder="{{'label.filtre'|translate}}">
    </div>
    <br />
    <div class="actions-bar" *hasRole="ROLE.INTERVENANT_ORGANISME_CREATION" >
      <button type="button" [routerLink]="['./new']" class="btn btn-primary">Ajouter</button>
    </div>
    <div id="liste-organismes">
      <table class="table table-striped" aria-label="Tableau des organismes">
        <thead>
          <tr>
            <th></th>
            <ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'raisonSociale',libelle:'page.common.organismes.liste.table.header.raisonSociale'}"></ng-container>
            <ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'type',libelle:'page.common.organismes.liste.table.header.type'}"></ng-container>
            <ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'siret',libelle:'page.common.organismes.liste.table.header.siret'}"></ng-container>
            <ng-container *ngTemplateOutlet="tableHeader;context:{libelle:'page.common.organismes.liste.table.header.adresse'}"></ng-container>
            <ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'mail',libelle:'page.common.organismes.liste.table.header.mail'}"></ng-container>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let organisme of organismes | filter : '*': searchString | orderBy:order.property:order.reverse:true">
            <td><img alt="Logo organisme" [src]="organisme.logo" style="height: 30px;" *ngIf="organisme.logo" /></td>
            <td>{{organisme.raisonSociale}}</td>
            <td>{{organisme.type.libelle}}</td>
            <td>{{organisme.siret}}</td>
            <td>
              <ng-container *ngTemplateOutlet="adresseTemplate;context:{organisme:organisme}"></ng-container>
            </td>
            <td>{{organisme.mail}}</td>
            <td>
              <span *hasRole="ROLE.INTERVENANT_ORGANISME_ABONNEMENT_ECRITURE">
                <fa-icon *ngIf="canModify(organisme)" class="clickable-icon" icon="user-tag" [routerLink]="['./edit-abonnements', organisme.id]"></fa-icon>
              </span>
              <span *hasRole="ROLE.INTERVENANT_ORGANISME_DETAIL_LECTURE">
                <fa-icon *ngIf="canModify(organisme)" class="clickable-icon" icon="edit" [routerLink]="['./edit',organisme.id]"></fa-icon>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<ng-template #tableHeader let-property="sortProperty" let-libelle="libelle">
  <th *ngIf="property" (click)="setOrder(property)" [class.sortable]="property">
    {{libelle | translate}}
    <fa-icon *ngIf="property" [icon]="getIcon(property)"></fa-icon>
  </th>
  <th *ngIf="!property">{{libelle | translate}}</th>
</ng-template>

<ng-template #adresseTemplate let-organisme="organisme">
  <div class="multilines-value">{{organisme.adresse}}</div>
  <div>{{organisme.codePostal}} {{organisme.ville}}</div>
  <div *ngIf="organisme.cedex">{{organisme.cedex}}</div>
  <div *ngIf="organisme.pays">{{organisme.pays.libelle}}</div>
</ng-template>

